import EventActionProto from '../event-action-proto'
import ProjectCollectionModel from "../../model2/project-collection/project-collection-model"
import {EVENT_BUS_SESSION_PORTFOLIO_CHANGED} from "../../model2/project-collection/events";

export default class EventPortfolioNew extends EventActionProto {

    constructor(sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)

        this.method     = sessionEvent.method
        this.header     = {
            portfolioId: sessionEvent.portfolioId,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        const newModel = new ProjectCollectionModel(this.data)
        gd.session.projectCollections.add(newModel)
        gd.bus.triggerEvent(EVENT_BUS_SESSION_PORTFOLIO_CHANGED)

        gd.modelBus.newUpdate('portfolio', this.method, this.header.portfolioId, this.data, this.header)
    }
}